import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Feedback } from './components/Feedback';
import { ThankYou } from './components/ThankYou';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Feedback />} />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

